import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";
import React from "react";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemNoWithCopy } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNoWithCopy/ItemNoWithCopy";
import { ItemDescription } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDescription/ItemDescription";
import styles from "../../../styles/common-media-styles.module.css";
import { ItemNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNo/ItemNo";

interface MediaItemCardBasicProps {
  item: Item;
  badges?: ItemBadge[] | undefined;
  canCopyItemNo?: boolean;
}

export const MediaItemCardBasic = ({
  item,
  badges,
  canCopyItemNo = true,
}: MediaItemCardBasicProps) => {
  return (
    <ItemCard
      badges={badges as ItemBadge[]}
      dataTestId={"media-item-card-basic"}
    >
      <div className={styles["item-card-root-row"]}>
        <ItemImage imageUrl={item.smallImageUrl || ""} />
        <div className={styles["item-card-root-column"]}>
          <ItemName name={item.name} />
          {canCopyItemNo ? (
            <ItemNoWithCopy itemNo={item.noFormatted} />
          ) : (
            <ItemNo itemNo={item.noFormatted} />
          )}
          <ItemDescription description={item.description || ""} />
        </div>
      </div>
    </ItemCard>
  );
};
